import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuthActions } from "@/hooks/useAuthActions";
import { useProfile } from "@/hooks/useProfile";
import { Home, Grid, Settings, DollarSign, Mail, LogIn, UserPlus, ShoppingBag } from "lucide-react";
import MobileNav from "./MobileNav";

const MainNav = () => {
  const { handleLogout } = useAuthActions();
  const { profile } = useProfile();

  return (
    <div className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="flex h-16 items-center px-4 container">
        <div className="flex items-center gap-6 flex-1">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/lovable-uploads/8d8be067-8fa3-4cb8-9ecf-189edbbc2574.png" 
              alt="UPnGO TrainerPad Logo" 
              className="h-8 object-contain"
            />
          </Link>
          
          <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
            <Link
              to="/"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <Home className="h-4 w-4" />
              Home
            </Link>
            <Link
              to="/dashboard"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <Grid className="h-4 w-4" />
              Dashboard
            </Link>
            <Link
              to="/marketplace"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <ShoppingBag className="h-4 w-4" />
              Marketplace
            </Link>
            <Link
              to="/services"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <Settings className="h-4 w-4" />
              Services
            </Link>
            <Link
              to="/prices"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <DollarSign className="h-4 w-4" />
              Prices
            </Link>
            <Link
              to="/contact"
              className="text-sm font-medium transition-colors hover:text-primary flex items-center gap-2"
            >
              <Mail className="h-4 w-4" />
              Contact
            </Link>
          </nav>
        </div>

        <div className="hidden md:flex items-center space-x-4">
          {profile ? (
            <Button onClick={handleLogout} variant="ghost" size="sm">
              Logout
            </Button>
          ) : (
            <>
              <Link to="/auth">
                <Button variant="ghost" size="sm" className="flex items-center gap-2">
                  <LogIn className="h-4 w-4" />
                  Login
                </Button>
              </Link>
              <Link to="/auth?mode=register">
                <Button size="sm" className="flex items-center gap-2">
                  <UserPlus className="h-4 w-4" />
                  Register
                </Button>
              </Link>
            </>
          )}
        </div>

        <div className="md:hidden">
          <MobileNav />
        </div>
      </div>
    </div>
  );
};

export default MainNav;